import { Injectable } from "@angular/core";
import {
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpEvent
} from "@angular/common/http";
import { Observable } from "rxjs";

@Injectable()
export class TimezoneInterceptor implements HttpInterceptor {
  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    return next.handle(
      req.clone({
        setHeaders: {
          // The getTimezoneOffset() method returns the time zone difference, in minutes, from current locale (host system settings) to UTC.
          // we are interested in the reverse. the UtcOffset is the offset from UTC to current locale.
          Timezone: (-new Date().getTimezoneOffset()).toString()
        }
      })
    );
  }
}
